/* eslint-disable @typescript-eslint/no-unsafe-return */
// eslint-disable no-restricted-imports
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// eslint-disable @typescript-eslint/no-unsafe-assignment
import {Link, useLocation} from 'react-router-dom';

import {useAppSelector, useAppDispatch} from 'store/hooks';
// eslint-disable-next-line no-restricted-imports
import logo from '../../../assets/img/logo.png';
import {clickOpenMenu} from 'store/menuOpenSlice';
import {hasRole} from 'utils';

const Sidebar = () => {
	const location = useLocation();

	const dispatch = useAppDispatch();

	const {open} = useAppSelector(state => state.menuOpen);
	const {roles} = useAppSelector(state => state.user);

	const handleOpen = () => dispatch(clickOpenMenu());

	return (
		<ul
			className={
				open
					? 'navbar-nav bg-gradient-primary sidebar sidebar-dark accordion toggled'
					: 'navbar-nav bg-gradient-primary sidebar sidebar-dark accordion'
			}
			id="accordionSidebar">
			{/* <!-- Sidebar - Brand --> */}
			<a
				className="sidebar-brand d-flex align-items-center justify-content-center m-0 p-0 bg-light"
				href="/dashboard">
				<div className="sidebar-brand-text m-0 p-md-2">
					<img
						src={logo}
						width={160}
						height={68}
						alt="PCRF"
						className="img-fluid"
					/>
				</div>
			</a>

			{/* <!-- Divider --> */}
			<hr className="sidebar-divider my-0" />

			{/* <!-- Nav Item - Dashboard --> */}
			{hasRole(roles, ['monitoring', 'monitoring_read_only']) && (
				<li
					className={`nav-item ${
						location.pathname === '/dashboard' ? 'active' : ''
					}`}>
					<Link className="nav-link" to="/dashboard">
						<i className="bi bi-speedometer2" />
						<span>Dashboard</span>
					</Link>
				</li>
			)}

			{/* Nav Item - Policy  */}
			{hasRole(roles, ['policy_engine', 'policy_engine_read_only']) && (
				<li
					className={`nav-item ${
						location.pathname.includes('policy') ? 'active' : ''
					}`}>
					<Link className="nav-link" to="/policy">
						<i className="bi bi-filter-square-fill" />
						<span title="Policy">Policy</span>
					</Link>
				</li>
			)}

			{/* Nav Item - SPR */}
			{hasRole(roles, [
				'subscriber_provision',
				'subscriber_read_only',
				'plan_provision',
				'plan_read_only',
			]) && (
				<li
					className={`nav-item ${
						location.pathname.includes('subscriber') ? 'active' : ''
					}`}>
					<Link className="nav-link" to="/subscriberProfile">
						<i className="bi bi-person-lines-fill" />
						<span title="SPR">SPR</span>
					</Link>
				</li>
			)}
			{/* Nav Item - Session Data Query */}
			{hasRole(roles, ['monitoring', 'monitoring_read_only']) && (
				<li
					className={`nav-item ${
						location.pathname === '/sessionDataQuery' ? 'active' : ''
					}`}>
					<Link className="nav-link" to="/sessionDataQuery">
						<i className="bi bi-server" />
						<span title="Session Data Query">Session Data Query</span>
					</Link>
				</li>
			)}

			{/* Nav Item - Configuration */}
			{hasRole(roles, ['system_admin', 'system_admin_read_only']) && (
				<>
					<li
						className={`nav-item ${
							location.pathname === '/configuration' ? 'active' : ''
						}`}>
						<Link className="nav-link" to="/configuration">
							<i className="bi bi-gear-fill" />
							<span title="Configuration">Configuration</span>
						</Link>
					</li>
				</>
			)}

			{/* Nav Item - Configuration */}
			{hasRole(roles, ['admin']) && (
				<>
					<li
						className={`nav-item ${
							location.pathname === '/users' ? 'active' : ''
						}`}>
						<Link className="nav-link" to="/users">
							<i className="bi bi-people-fill" />
							<span title="Users">Users</span>
						</Link>
					</li>
				</>
			)}

			{/* Divider */}
			<hr className="sidebar-divider d-none d-md-block" />
			{/* Sidebar Toggler (Sidebar) */}

			{/* Divider */}
			<hr className="sidebar-divider d-none d-md-block" />
			{/* Sidebar Toggler (Sidebar) */}
			<div className="text-center d-none d-md-inline">
				<button
					onClick={handleOpen}
					className="rounded-circle border-0"
					id="sidebarToggle"
				/>
			</div>
		</ul>
	);
};

export default Sidebar;
